import AvailableBalance from './AvailableBalance';

export default AvailableBalance;